import { RouteConfig } from 'vue-router';
const Folder = () => import('./views/folder.vue');
const Detail = () => import('./views/detail.vue');
const routers: RouteConfig[] = [
    {
        path: 'folder',
        name: 'folder',
        component: Folder
    },
    {
        path: 'detail',
        name: 'detail',
        component: Detail
    },
    {
        path: '',
        redirect: 'folder'
    },
];
export default routers;

